import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function Login() {
  const { user, login, loading } = useAuth();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) {
    const dest = location.state?.from?.pathname || "/dashboard";
    return <Navigate to={dest} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(username, password);
    } catch (err) {
      setError(err.message || "Login fehlgeschlagen");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-fh-gray-light px-4">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img
            src={`${process.env.PUBLIC_URL}/fh_logo_circle.png`}
            alt="Freeheeler"
            className="h-20 w-20 logo-clean"
          />
          <h1 className="mt-4 text-2xl font-bold">Verleih-Portal</h1>
          <p className="text-sm text-fh-gray">Mitarbeiter-Login</p>
        </div>

        <form onSubmit={onSubmit} className="card p-6 space-y-4">
          {error && (
            <div className="bg-fh-red/10 border-l-4 border-fh-red px-4 py-3 rounded text-sm text-fh-red-dark">
              {error}
            </div>
          )}
          <div>
            <label className="label-field" htmlFor="username">Benutzername</label>
            <input
              id="username"
              type="text"
              className="input-field"
              autoComplete="username"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div>
            <label className="label-field" htmlFor="password">Passwort</label>
            <input
              id="password"
              type="password"
              className="input-field"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={submitting}>
            {submitting ? "Wird angemeldet…" : "Anmelden"}
          </button>
        </form>

        <p className="mt-6 text-xs text-center text-fh-gray">
          Kein Konto? Frag deinen Admin nach Zugangsdaten.
        </p>
      </div>
    </div>
  );
}
